const version = 1;
async function getDexie(storageKey) {
    const Dexie = await import('dexie').then((m) => m.Dexie);
    const db = new Dexie('one-inch-long-time-async-cache_' + storageKey);
    db.version(version).stores({
        cache: ['key', 'value', 'timestamp'].join(', '),
    });
    return Reflect.get(db, 'cache');
}
export class LongTimeAsyncCache {
    constructor(storageKey, ttlDays) {
        this.storageKey = storageKey;
        this.ttlDays = ttlDays;
    }
    async set(key, value) {
        const db = await this.getDexie(this.storageKey);
        await db.put({ key: key.toLowerCase(), value, timestamp: Date.now() });
        this.cleanOldRecords().catch(console.error);
    }
    async get(key) {
        const _key = key.toLowerCase();
        const db = await this.getDexie(this.storageKey);
        const result = await db
            .filter((item) => Date.now() - item.timestamp < this.ttlDays * 8.64e7 && item.key === _key)
            .first();
        this.cleanOldRecords().catch(console.error);
        return result?.value ?? null;
    }
    async getAll() {
        const db = await this.getDexie(this.storageKey);
        const result = await db
            .filter((item) => Date.now() - item.timestamp < this.ttlDays * 8.64e7)
            .toArray();
        this.cleanOldRecords().catch(console.error);
        return result.map((record) => record.value);
    }
    async has(key) {
        const result = await this.get(key);
        return result !== null;
    }
    async delete(key) {
        try {
            const db = await this.getDexie(this.storageKey);
            await db.delete(key);
            this.cleanOldRecords().catch(console.error);
            return true;
        }
        catch {
            return false;
        }
    }
    async clear() {
        const db = await this.getDexie(this.storageKey);
        db.clear();
    }
    async size() {
        await this.cleanOldRecords().catch(console.error);
        const db = await this.getDexie(this.storageKey);
        return db.count();
    }
    async cleanOldRecords() {
        const db = await this.getDexie(this.storageKey);
        await db
            .where('timestamp')
            .below(Date.now() - this.ttlDays * 8.64e7)
            .delete();
    }
    async getDexie(storageKey) {
        if (this.storage !== undefined) {
            return this.storage;
        }
        this.storage = (await getDexie(storageKey));
        return this.storage;
    }
}
//# sourceMappingURL=long-time-async-cache.js.map